module.exports = __webpack_public_path__ + "static/media/Vector-7.c662fce5.svg";